module.exports = [{
      plugin: require('../gatsby-browser.ts'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../../node_modules/.pnpm/gatsby@5.15.0_babel-eslint@10.1.0_eslint@9.39.1_jiti@2.6.1___react-dom@18.3.1_react@18.3.1__r_5idwyqknwenst4stuqevv23ibu/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
